const images = {
  benefits: [
    'https://pastatic.picsart.com/cms-pastatic/f2af715f-9f8d-49ff-9b49-7887f91c3312.png',
    'https://pastatic.picsart.com/cms-pastatic/4fa4ccf6-be96-47d5-a675-9268e06250ed.png',
    'https://pastatic.picsart.com/cms-pastatic/ea73de49-20c7-4eb7-8507-58394ef4f5c8.png',
  ],
};

export default images;
